import ApiService from "../../api/api.service";
import { GET_COMMODITY_FORM, GET_COMMODITY_FORM_DETAIL, SAVE_COMMODITY_FORM_DETAIL, GET_COMMODITY_LOCATION_LIST, 
	GET_COMMODITY_PRICE_LIST, GET_COMMODITY_LIST, DELETE_FORM, GET_EDIT_COMMODITY_FORM_DETAIL, UPDATE_COMMODITY_FORM } from "../actions.type";

const getDefaultCommoditiesState = () => {
	return {
		commodityForm: {},
		commodityFormDetail: {},
		commodityFormTotal: 0,
		saveCommodityFormDetail: {}, 
		commodityLocationList: {},
		commodityPriceList: {},
		commodityList: {},
		deleteForm: {},
		editCommodityFormDetail: {},
		updateCommodityForm: {},
	}
};

const state = getDefaultCommoditiesState();

const getters = {

	getCommodityForm (state) {
		return state.commodityForm;
	},
	getCommodityFormDetail (state) {
		return state.commodityFormDetail;
	},
	getSaveCommodityFormDetail (state) {
		return state.saveCommodityFormDetail;
	},
	getCommodityLocationList (state) {
		return state.commodityLocationList;
	},
	getCommodityPriceList (state) {
		return state.commodityPriceList;
	},
	getCommodityList (state) {
		return state.commodityList;
	},
	getDeleteForm (state) {
		return state.deleteForm;
	},
	getEditCommodityFormDetail (state) {
		return state.editCommodityFormDetail;
	},
	getUpdateCommodityForm (state) {
		return state.updateCommodityForm;
	},
};

const mutations = {

	setCommodityForm (state, data) {
		state.commodityForm = data
	},
	setCommodityFormDetail (state, data) {
		state.commodityFormDetail = data
	},
	setSaveCommodityFormDetail (state, data) {
		state.saveCommodityFormDetail = data
	},
	setCommodityLocationList (state, data) {
		state.commodityLocationList = data
	},
	setCommodityPriceList (state, data) {
		state.commodityPriceList = data
	},
	setCommodityList (state, data) {
		state.commodityList = data
	},
	setDeleteForm (state, data) {
		state.deleteForm = data
	},
	setEditCommodityFormDetail (state, data) {
		state.editCommodityFormDetail = data
	},
	setUpdateCommodityForm (state, data) {
		state.updateCommodityForm = data
	},
	
};


const actions = {

	[GET_COMMODITY_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setCommodityForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_COMMODITY_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setCommodityFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[SAVE_COMMODITY_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setSaveCommodityFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_COMMODITY_LOCATION_LIST](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setCommodityLocationList',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_COMMODITY_PRICE_LIST](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setCommodityPriceList',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_COMMODITY_LIST](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setCommodityList',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[DELETE_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setDeleteForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[GET_EDIT_COMMODITY_FORM_DETAIL](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setEditCommodityFormDetail',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	[UPDATE_COMMODITY_FORM](context, credentials) {
		return new Promise((resolve, reject) => {
			ApiService.setHeader();
			ApiService.post(credentials.api, credentials.data)
			.then(({ data }) => {
				if (data.message == 'Unauthenticated') {
					window.location.replace('/');
				}
				context.commit('setUpdateCommodityForm',data);
				resolve();
			})
			.catch(({ response }) => {
				console.log("Something went wrong");
			});
		})
		.catch(response => {
			if(response.logout == true){
				window.location.replace('/');
			}
			console.log("Something went wrong");
		});
	},
	
};

export default {
	getters,
	actions,
	mutations,
	state
}